import { ApiHelper } from '../../../../common/helpers/ApiHelper'
import { extractCrmNumbersItems, withVendorProjectIdQueryParam } from '../WhatsappUtils'

export const LOADING_TEMPLATE_OPTIONS = [{ key: '', label: 'Loading…' }]

function normalizeTemplatesResponse(data) {
  if (!data) return []
  if (Array.isArray(data)) return data
  if (Array.isArray(data.items)) return data.items
  if (Array.isArray(data.templates)) return data.templates
  if (Array.isArray(data.data)) return data.data
  return []
}

function crmNumberHasWhatsApp(item) {
  return (item && item.providers || []).some(p => String(p).toUpperCase() === 'WHATSAPP')
}

export function getDefaultWabaNumber(crmNumbers) {
  const list = crmNumbers || []
  const primary = list.find(item => item && String(item.primaryWaNumber || '').toUpperCase() === 'YES' && crmNumberHasWhatsApp(item))
  const pick = primary || list.find(crmNumberHasWhatsApp)
  return (pick && pick.phone) || ''
}

export function crmNumbersFromResult(crmnumbersResult) {
  return extractCrmNumbersItems(crmnumbersResult)
}

export async function fetchApprovedWhatsappTemplates(ms, orgId, fromNumber, crmNumbers) {
  if (!fromNumber) return []
  const data = await ApiHelper.callAwait({
    ms,
    method: 'GET',
    paths: ['hooks'],
    queryParams: withVendorProjectIdQueryParam(
      { orgId, fromNumber, bridgePath: 'whatsapptemplates' },
      fromNumber,
      crmNumbers
    ),
  })
  return normalizeTemplatesResponse(data)
    .filter(t => t && String(t.status || '').toUpperCase() === 'APPROVED')
    .map(t => ({
      name: String(t.name || t.templateName || t.title || '').trim(),
      language: t.language || '',
      category: t.category || '',
      components: Array.isArray(t.components) ? t.components : [],
      status: t.status || '',
    }))
    .filter(t => t.name)
}

export function templateSelectOptions(templates) {
  return (templates || []).map(t => ({
    key: t.name,
    label: t.name,
  }))
}

export function templatesByNameMap(templates) {
  const map = {}
  ;(templates || []).forEach(t => {
    if (t && t.name) map[t.name] = t
  })
  return map
}
